import * as React from "react";
import { Form, useFormApi } from "informedv4";
import { TextBox } from "../../forms/informedv4/TextBoxV4";
import { Required, RequiredNotBlank } from "../../forms/validation/Required";
import { Dropdown } from "../../forms/informedv4/DropdownV4";
import { PopulationGroup, PredictedSet, CoreRace } from "webportalclient";
import { Checkbox } from "../../forms/informedv4/CheckboxV4";
import { nameof } from "ts-simple-nameof";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";

export interface PopulationGroupFormModel {
    Name: string;
    CoreRace: string;
    PredictedSet: string;
    CorrectionFactor: number;
    Disabled: boolean;
}

export const PopulationGroupFormBody = () => {
    const client = useWebPortalApiClient();
    const [coreRaces, setCoreRaces] = React.useState<CoreRace[]>([]);
    const [predictedSets, setPredictedSets] = React.useState<PredictedSet[]>([]);

    React.useEffect(() => {
        const getData = async () => {
            const raceResult = await client.client.getRaces();

            setCoreRaces(raceResult.value);

            const predictedSetsResult = await client.client.getPredictedSets("id,name",undefined,"name");
            setPredictedSets(predictedSetsResult.value);
        }

        getData();
    }, []);

    return (
        <>
            <div className="row">
                <div className="form-group col-md-4 col-sm-4 col-xs-12">
                    <label htmlFor="select-site">Name</label>
                    <TextBox
                        name={nameof<PopulationGroupFormModel>(f => f.Name)}
                        id={nameof<PopulationGroupFormModel>(f => f.Name)}
                        key={nameof<PopulationGroupFormModel>(f => f.Name)}
                        field={nameof<PopulationGroupFormModel>(f => f.Name)}
                        validate={RequiredNotBlank}
                    />
                </div>
                <div className="form-group col-md-4 col-sm-4 col-xs-12">
                    <label htmlFor="CoreRace">Core Race</label>
                    <Dropdown
                        name={nameof<PopulationGroupFormModel>(f => f.CoreRace)}
                        id={nameof<PopulationGroupFormModel>(f => f.CoreRace)}
                        key={nameof<PopulationGroupFormModel>(f => f.CoreRace)}
                        field={nameof<PopulationGroupFormModel>(f => f.CoreRace)}
                        validate={Required}
                    >
                        <option key="OptionBlank" value=""></option>
                        {coreRaces.map(cr => (
                            <option
                                key={`${cr.coreRaceKey}`}
                                value={cr.coreRaceKey}
                            >
                                {cr.name}
                            </option>
                        ))}
                    </Dropdown>
                </div>
                <div className="form-group col-md-4 col-sm-4 col-xs-12">
                    <label htmlFor="PredictedSet">Predicted Set</label>
                    <Dropdown
                        name={nameof<PopulationGroupFormModel>(f => f.PredictedSet)}
                        id={nameof<PopulationGroupFormModel>(f => f.PredictedSet)}
                        key={nameof<PopulationGroupFormModel>(f => f.PredictedSet)}
                        field={nameof<PopulationGroupFormModel>(f => f.PredictedSet)}
                        className="form-group col-md-4 col-sm-4 col-xs-12"
                        validate={Required}
                    >
                        <option key="OptionBlank" value=""></option>
                        {predictedSets.map(ps => (
                            <option
                                key={`Option${ps.id}`}
                                value={ps.id}
                            >
                                {ps.name}
                            </option>
                        ))}
                    </Dropdown>
                </div>
            </div>
            <div className="row">
                <div className="form-group col-md-4 col-sm-4 col-xs-12">
                    <label htmlFor="CorrectionFactor">Correction Factor</label>
                    <TextBox
                        name={nameof<PopulationGroupFormModel>(f => f.CorrectionFactor)}
                        id={nameof<PopulationGroupFormModel>(f => f.CorrectionFactor)}
                        key={nameof<PopulationGroupFormModel>(f => f.CorrectionFactor)}
                        field={nameof<PopulationGroupFormModel>(f => f.CorrectionFactor)}
                        type="number"
                        validate={Required}
                    />
                </div>
                <div className="form-group col-md-4 col-sm-4 col-xs-12">
                    <label htmlFor="Disabled">Disabled</label>
                    <Checkbox
                        name="Disabled"
                        id="Disabled"
                        field="Disabled"
                        label="Disabled"
                    />
                </div>
            </div>
        </>
    );
}
